import { render } from "./ShowOrder.vue?vue&type=template&id=70e615eb&scoped=true"
import script from "./ShowOrder.vue?vue&type=script&lang=js"
export * from "./ShowOrder.vue?vue&type=script&lang=js"

import "./ShowOrder.vue?vue&type=style&index=0&id=70e615eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e615eb"]])

export default __exports__